import cn from "classnames";
import React from "react";
import { Check } from "react-feather";

type CheckboxProps = React.ComponentProps<"input"> & {
  error?: boolean;
};

const Checkbox = ({
  className,
  checked,
  error,
  disabled,
  ...props
}: CheckboxProps) => {
  return (
    <div>
      <div
        className={cn(
          "w-6 h-6 block",
          "border-2 border-solid border-gray-300 focus:border-primary",
          "rounded shadow-none",
          "outline-none focus:outline-none focus:ring ring-primary ring-opacity-40",
          "hover:border-primary hover:ring transition-all",
          "flex items-center justify-center",
          { "border-green-500": checked },
          { "border-red-500": error },
          { "bg-gray-400": disabled },
          className
        )}
      >
        <Check
          className={cn(
            "text-primary transition-opacity",
            checked ? "opacity-100" : "opacity-0"
          )}
          size={18}
        />
      </div>
      <input
        type="checkbox"
        style={{
          border: "0",
          clip: "rect(0 0 0 0)",
          height: "1px",
          margin: "-1px",
          overflow: "hidden",
          padding: "0",
          position: "absolute",
          whiteSpace: "nowrap",
          width: "1px",
        }}
        checked={checked}
        {...props}
      />
    </div>
  );
};

export default Checkbox;
